import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import SocialIcons from "./SocialIcons";
import axios from "axios";
import api from '../api.js';

export default function Signup() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');

  // inline error messages
  const [pwdError, setPwdError] = useState('');
  const [confirmError, setConfirmError] = useState('');
  const [formError, setFormError] = useState('');
  const [suggestion, setSuggestion] = useState('');

  const validatePassword = (pwd) => {
    const re = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
    return re.test(pwd);
  };

  const generateStrongPassword = (len = 12) => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@$!%*#?&";
    let out = "";
    for (let i = 0; i < len; i++) out += chars.charAt(Math.floor(Math.random() * chars.length));
    return out;
  };

  // use a suggested password (fills both fields)
  const applySuggestion = (s) => {
    setPassword(s);
    setConfirm(s);
    setSuggestion('');
    setPwdError('');
    setConfirmError('');
  };
  const handleSignup = async (e) => {
    e.preventDefault();
    setFormError("");
    let ok = true;
    // validation code omitted for brevity (keep existing)

    if (!ok) return;

    try {
      // call signup
      await api.post("/auth/signup", {
        email,
        password,
        full_name: name || null,
        role: null,          // because user will choose later
        product_id: null    // because user will choose later
      });

      // auto-login after signup
      const loginRes = await api.post("/auth/login", { email, password });
      localStorage.setItem("access_token", loginRes.data.access_token);
      localStorage.setItem("refresh_token", loginRes.data.refresh_token);

      //navigate("/product-selector");

      window.location.href = "https://stridenext.in/auth/callback?token=" + loginRes.data.access_token;

    } catch (err) {
      setFormError(err.response?.data?.detail || "Signup failed");
    }
  };


  //before intergration code
  {/*const handleSignup = async (e) => {
    e.preventDefault();
   setFormError('');
    let ok = true;

    if (!validatePassword(password)) {
      setPwdError('Password must be min 8 chars, include 1 letter, 1 number and 1 special char');
      ok = false;
    } else {
      setPwdError('');
    }

    if (password !== confirm) {
      setConfirmError('Passwords do not match');
      ok = false;
    } else {
      setConfirmError('');
    }

    if (!ok) return;

    try{
      // Call backend signup API and send intimation mail
      // const res = await axios.post('http://localhost:8000/auth/signup', { name, email, password });
      // localStorage.setItem('token', res.data.access_token);
      // mock:
      localStorage.setItem('token', 'demo-token');
      navigate('/product-selector');
    }catch(err){
      setFormError(err.response?.data?.detail || 'Signup failed');
    }
  };*/}

  return (
    <div className="auth-container">
      <h2>Sign Up</h2>
      <form onSubmit={handleSignup}>
        <div className="input-wrap">
          <input type="text" placeholder="Full Name" value={name}
            onChange={(e) => setName(e.target.value)} required />
        </div>
        <div className="input-wrap">
          <input type="email" placeholder="Email" value={email}
            onChange={(e) => setEmail(e.target.value)} required />
        </div>


        <div className="input-wrap" style={{ position: 'relative' }}>
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => {
              const v = e.target.value;
              setPassword(v);
              setSuggestion(''); // clear any previous suggestion when user types
              if (!validatePassword(v)) {
                setPwdError('Weak password');
                // create a single suggestion if none exists yet
                if (!suggestion) setSuggestion(generateStrongPassword(12));
              } else {
                setPwdError('');
                setSuggestion('');
              }
            }}
            required
          />
          {/*show suggestion below the field (no button inside the field)*/}
          {pwdError && <div className="field-error">{pwdError}</div>}
          {suggestion && (
            <div className="password-suggestion" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                Suggested strong password: <code style={{ fontSize: 13, padding: '2px 6px', background: '#f3f4f6', borderRadius: 6 }}>{suggestion}</code>
              </div>
              <button type="button" className="btn-compact" onClick={() => applySuggestion(suggestion)} aria-label="Use suggested password">Use</button>
            </div>
          )}
        </div>

        <div className="input-wrap">
          <input type="password" placeholder="Confirm Password" value={confirm}
            onChange={(e) => { setConfirm(e.target.value); if (password !== e.target.value) setConfirmError('Passwords do not match'); else setConfirmError(''); }} required />
          {confirmError && <div className="field-error">{confirmError}</div>}
        </div>

        {formError && <div className="field-error" style={{ textAlign: 'center' }}>{formError}</div>}

        <button className="primary blue" type="submit">Sign Up</button>
      </form>

      <SocialIcons />

      <p className="switch-line">Already have an account? <Link to="/">Sign In</Link></p>

      {/* <div className="password-hint">
        Password must be at least 8 characters and include 1 letter, 1 number, and 1 special character.
      </div> */}
    </div>
  );
}
